// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  width: 130px;
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/rewards-components/rewards-success-fail-message/rewards-success-fail-message.component.scss"],"names":[],"mappings":"AAAI;EACI,YAAA;EACA,YAAA;AACR","sourcesContent":["    img {\n        width: 130px;\n        margin: auto;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
